const CONSTANTS = {
    COURSE: "course",
    SCO: "sco",
};

export {CONSTANTS}